/// <reference path="ListBase.js" />

var ActivePlazasListLastInstances = {};

class ActivePlazasList extends ListBase {
	constructor(el, options) {
		const classList = document.getElementById(el).classList;

		//Class is reused for friends list and several other lists (which uses different paging effect)
		if (classList.contains("myFriendsList") || classList.contains("guestBookList"))
			super(el, Object.assign({ pagingEffect: 'returnToTop' }, options));
		else if (classList.contains("commentsList"))
			super(el, Object.assign({ pagingEffect: 'returnToTop', customProgressIndicator: 'div' }, options));
		else if (classList.contains("memberList"))
			super(el, Object.assign({ pagingEffect: 'vertSlide', legacy: false }, options));
		else if (classList.contains("messageList"))
			super(el, Object.assign({ pagingEffect: 'returnToTop', legacy: true, fixDimensions: false }, options));
		else if (classList.contains("inventoryList"))
			super(el, Object.assign({ pagingEffect: 'horizSlide' }, options));
		else if (classList.contains("designedItemList"))
			super(el, Object.assign({ pagingEffect: 'horizSlide' }, options));
		else if (classList.contains("shapeList"))
			super(el, Object.assign({ pagingEffect: 'horizSlide' }, options));
		else
			super(el, Object.assign({ pagingEffect: 'vertSlide', removeButtonsForOnePageLists: true }, options));

		ActivePlazasListLastInstances[options.activePlazaListIdentifier] = this;
	}

	loadPage(page, search) {
		super.loadPage(page);

		this.resetDimensions();

		if (search === null || search === undefined) {
			if (this.options.search === null || this.options.search === undefined) {
				search = "";
			} else {
				search = this.options.search;
			}
		}

		var url = this.options.url.replace('PLH_pagenum', page).replace('PLH_search', search);
		var minslider = document.getElementById("contentcontent_grade_slider_min");
		var maxslider = document.getElementById("contentcontent_grade_slider_max");
		if (minslider && maxslider) {
			var min = minslider.value || 0;
			var max = maxslider.value || 8;
			url = url.replace('PLH_gradeMin', min).replace('PLH_gradeMax', max);
		} else {
			url = url.replace('PLH_gradeMin', 0).replace('PLH_gradeMax', 8);
		}
		this.standardJSONRequest(url);

		return true;
	}
}
